import { LikedItem, PositioningOutputSnapshot } from '../../../../src/commonTypes';

const INSPIRE_SOURCE_NODE_TYPES = new Set<LikedItem['type']>([
	'node',
	'image-inspire',
	'video-inspire',
]);

/**
 * Plain Inspire nodes keep their original identity on the personal Synthesise
 * board. Generated outputs must always materialise their structured card,
 * even when a legacy saved item also carries the node that seeded it.
 */
export const shouldReuseInspireSourceNode = (
	likedItem: LikedItem,
	positioningOutput?: PositioningOutputSnapshot
): boolean => {
	if (!likedItem.nodeUid) return false;
	if (!positioningOutput) return true;
	return INSPIRE_SOURCE_NODE_TYPES.has(likedItem.type);
};

/** Label stored on the board node; persona/character cards keep the name, not a one-word role. */
export const boardLabelForPositioningOutput = (snapshot: PositioningOutputSnapshot): string => {
	if (snapshot.payload.kind === 'cluster') return snapshot.title;
	if (snapshot.type === 'persona' || snapshot.type === 'character') {
		return snapshot.title || snapshot.summary || snapshot.subtitle || '';
	}
	return snapshot.summary || snapshot.subtitle || snapshot.title;
};
